module.exports = __webpack_public_path__ + "img/insurance_policy.47d5d768.png";